module.exports = __webpack_public_path__ + "img/woman-purple-blue-bg-opaque-no-bud.feb69f66.png";